import Icon from 'scripts/components/basic/Icon.vue';
import CartInit from 'scripts/components/cart/CartInit.vue';
import Sidecart from 'scripts/components/cart/Sidecart.vue';
import CartLineItem from 'scripts/components/cart/CartLineItem.vue';
import CartItemsCount from 'scripts/components/cart/CartItemsCount.vue';
import QuantityLimits from 'scripts/components/quantity-limits.js'

export default {
  Icon,
  CartInit,
  Sidecart,
  CartLineItem,
  CartItemsCount,
  QuantityLimits
};
